import * as React from 'react';
import {
  MasonrySidebarLayoutRenderer,
  MasonrySidebarLayoutRendererProps,
} from '@leagueplatform/masonry-renderers';

export const NODE_TYPE_SIDEBAR_LAYOUT = 'sidebarLayout';

export const SidebarLayoutRenderer = (
  props: MasonrySidebarLayoutRendererProps,
  // eslint-disable-next-line react/jsx-props-no-spreading
) => <MasonrySidebarLayoutRenderer {...props} />;
